/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const SadFaceIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path
      d="M9.02396 8.24912V11.1361M16.7979 8.24912V11.1361M7.92188 18.9561C7.92188 18.9561 8.24657 16.1825 12.9109 16.1825C17.5753 16.1825 18.4219 18.9561 18.4219 18.9561M24.5719 13.3943C24.5719 19.8338 19.3504 25.0553 12.9109 25.0553C6.47151 25.0553 1.25 19.8338 1.25 13.3943C1.25 6.95491 6.47151 1.7334 12.9109 1.7334C19.3504 1.7334 24.5719 6.95491 24.5719 13.3943Z"
      stroke="#1D1D1B"
      strokeWidth="1.69636"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
